export const PRIMARY_BLUE = '#163873';
export const TEXT_WHITE = '#FFFFFF';
export const BORDER_GREY = '#808282';
export const TEXT_GREY = '#5C677D';
export const TEXT_BLACK = '#010404';

